import { apiClient } from "@/shared/api/client";
import type {
  AuthResponse,
  EmailVerificationResponse,
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  LoginPayload,
  ResetPasswordPayload,
  ResetPasswordResponse,
  SignupPayload,
  User,
} from "@/features/auth/types";

export async function signup(payload: SignupPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/signup", payload);
  return data;
}

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/login", payload);
  return data;
}

export async function fetchMe(): Promise<User> {
  const { data } = await apiClient.get<User>("/auth/me");
  return data;
}

export async function verifyEmail(token: string): Promise<EmailVerificationResponse> {
  const { data } = await apiClient.get<EmailVerificationResponse>(
    `/auth/verify-email/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function devSkipVerification(accessToken: string): Promise<User> {
  const { data } = await apiClient.post<User>(
    "/auth/dev/skip-verification",
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return data;
}

export async function devLoginSkipVerification(
  payload: LoginPayload,
): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>(
    "/auth/dev/login-skip-verification",
    payload,
  );
  return data;
}

export async function forgotPassword(
  payload: ForgotPasswordPayload,
): Promise<ForgotPasswordResponse> {
  const { data } = await apiClient.post<ForgotPasswordResponse>(
    "/auth/forgot-password",
    payload,
  );
  return data;
}

export async function resetPassword(
  payload: ResetPasswordPayload,
): Promise<ResetPasswordResponse> {
  const { data } = await apiClient.post<ResetPasswordResponse>(
    "/auth/reset-password",
    payload,
  );
  return data;
}
